<template>
	<div class="analysis-settings">
		<slot />
		<label>
			{{ t("comparableAnalysis.analysisType") }}
			<select v-model="input.analysisType" :disabled="disabled">
				<option v-for="type in Object.values(ComparableAnalysisType)" :key="type" :value="type">
					{{ t(`comparableAnalysis.types.${type}`) }}
				</option>
			</select>
		</label>
		<label v-if="showAssumptions">
			{{ t("comparableAnalysis.reportDate") }}
			<input
				type="date"
				:value="input.reportDate"
				:disabled="disabled"
				@input="input.reportDate = ($event.target as HTMLInputElement).value || null"
			/>
		</label>
		<label v-if="showAssumptions">
			{{ t("comparableAnalysis.annualGrowthRate") }}
			<input v-model.number="input.annualGrowthRate" type="number" step="any" required :disabled="disabled" />
		</label>
	</div>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n"
import { ComparableAnalysisType, type ComparableAnalysisInput } from "@/graphql"
const input = defineModel<ComparableAnalysisInput>({ required: true })
withDefaults(defineProps<{ disabled?: boolean; showAssumptions?: boolean }>(), { showAssumptions: true })
const { t } = useI18n()
</script>
<style scoped>
.analysis-settings {
	display: flex;
	flex-wrap: wrap;
	gap: var(--spacing-md);
	label {
		display: flex;
		flex: 1 1 180px;
		flex-direction: column;
		gap: var(--spacing-xs);
		font-size: var(--font-size-xs);
		color: var(--neutral-600);
	}
	input,
	select {
		min-width: 0;
		height: var(--size-button-s);
		box-sizing: border-box;
		padding: 0 var(--spacing-sm);
		border: var(--border-width-thin) solid var(--neutral-400);
		border-radius: var(--border-radius-base);
		background: var(--neutral-0);
		color: var(--neutral-900);
		font: inherit;
		font-size: var(--font-size-small);
		&:focus-visible {
			outline: 2px solid var(--primary-green);
		}
	}
}
</style>
